import { Box, Flex, Image, Text, useBreakpointValue } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import CtaButton from './CtaButton';
import joePhoto from '../images/joeWellsPortrait.webp';

// Create motion components
const MotionFlex = motion(Flex);
const MotionBox = motion(Box);

/**
 * Home page teaser for the About page: a photo of Joe, a short intro, and a CTA
 */
export default function AboutPreview() {

	const titleFontSize = useBreakpointValue({ base: "32px", md: "36px", lg: "40px" });

	return (
		<Flex
			width={"100%"}
			backgroundColor={"blue.200"}
		>
			<Flex
				width={{ base: "90%", lg: "80%" }}
				maxWidth={"1200px"}
				margin={"auto"}
				paddingY={{ base: 10, md: 16 }}
				flexDirection={{ base: "column", md: "row" }}
				alignItems={"center"}
				gap={{ base: 8, md: 12 }}
			>
				{/* Photo */}
				<MotionBox
					flexShrink={0}
					width={{ base: "70%", sm: "50%", md: "35%" }}
					initial={{ opacity: 0, x: -50 }}
					whileInView={{ opacity: 1, x: 0 }}
					viewport={{ once: true, amount: 0.3 }}
					transition={{ duration: 0.7, ease: "easeOut" }}
				>
					<Image
						src={joePhoto}
						alt="Joe Wells"
						width={"100%"}
						aspectRatio={4 / 5}
						objectFit={"cover"}
						borderRadius={"md"}
						boxShadow={"lg"}
					/>
				</MotionBox>

				{/* Text + CTA */}
				<MotionFlex
					flexDirection={"column"}
					alignItems={{ base: "center", md: "flex-start" }}
					textAlign={{ base: "center", md: "left" }}
					gap={5}
					initial={{ opacity: 0, y: 30 }}
					whileInView={{ opacity: 1, y: 0 }}
					viewport={{ once: true, amount: 0.3 }}
					transition={{ duration: 0.6, delay: 0.2, ease: "easeOut" }}
				>
					<Text
						fontSize={titleFontSize}
						fontFamily={"Martel"}
						fontWeight={"700"}
						color={"white.500"}
					>
						Meet Joe Wells
					</Text>

					<Text
						fontSize={"18px"}
						fontFamily={"Montserrat"}
						fontWeight={"500"}
						color={"white.500"}
					>
						Joe Wells is a board-certified criminal defense attorney with nearly two decades of experience defending clients in Houston and beyond. Named Harris County’s top criminal defense lawyer in 2024, he is also a member of the National Trial Lawyers Top 100.
					</Text>

					<CtaButton to={"/about"}>
						More About Joe
					</CtaButton>
				</MotionFlex>
			</Flex>
		</Flex>
	);
}
